/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_SuccessInputs */

const en_report_success = /** @type {(inputs: Report_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message reported. Moderators will review shortly.`)
};

const id_report_success = /** @type {(inputs: Report_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesan dilaporkan. Moderator akan segera meninjaunya.`)
};

/** @type {(inputs: Report_SuccessInputs) => LocalizedString} */
const es_report_success = en_report_success;

/** @type {(inputs: Report_SuccessInputs) => LocalizedString} */
const fr_report_success = en_report_success;

/** @type {(inputs: Report_SuccessInputs) => LocalizedString} */
const de_report_success = en_report_success;

/** @type {(inputs: Report_SuccessInputs) => LocalizedString} */
const ja_report_success = en_report_success;

/** @type {(inputs: Report_SuccessInputs) => LocalizedString} */
const zh_report_success = en_report_success;

/** @type {(inputs: Report_SuccessInputs) => LocalizedString} */
const ar_report_success = en_report_success;

/** @type {(inputs: Report_SuccessInputs) => LocalizedString} */
const it_report_success = en_report_success;

/** @type {(inputs: Report_SuccessInputs) => LocalizedString} */
const ru_report_success = en_report_success;

/** @type {(inputs: Report_SuccessInputs) => LocalizedString} */
const pt_report_success = en_report_success;

/** @type {(inputs: Report_SuccessInputs) => LocalizedString} */
const ko_report_success = en_report_success;

/**
* | output |
* | --- |
* | "Message reported. Moderators will review shortly." |
*
* @param {Report_SuccessInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const report_success = /** @type {((inputs?: Report_SuccessInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_SuccessInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_report_success(inputs)
	if (locale === "es") return es_report_success(inputs)
	if (locale === "fr") return fr_report_success(inputs)
	if (locale === "de") return de_report_success(inputs)
	if (locale === "ja") return ja_report_success(inputs)
	if (locale === "zh") return zh_report_success(inputs)
	if (locale === "ar") return ar_report_success(inputs)
	if (locale === "id") return id_report_success(inputs)
	if (locale === "it") return it_report_success(inputs)
	if (locale === "ru") return ru_report_success(inputs)
	if (locale === "pt") return pt_report_success(inputs)
	return ko_report_success(inputs)
});